import {
	reMeasurementUnitConstants
}from './constants'
import actions from '../../../actions'

const initialState =
{
	isSending  : false,
	paged      : {},
	list       : [],
	changed    : null,
	pagedAudit : null,
	countAudit : null
}

export default function (state = initialState, action){
	switch (action.type){
		case reMeasurementUnitConstants.GetPaged.REQUEST:
		case reMeasurementUnitConstants.GetPagedAudit.REQUEST:
		case reMeasurementUnitConstants.GetPagedAll.REQUEST:
		case reMeasurementUnitConstants.GetList.REQUEST:
		case reMeasurementUnitConstants.Create.REQUEST:
		case reMeasurementUnitConstants.Delete.REQUEST:
		case reMeasurementUnitConstants.Restore.REQUEST:
		case reMeasurementUnitConstants.Update.REQUEST:
			return {
				...state,
				isSending : true,
				changed   : null
			}
		case reMeasurementUnitConstants.GetPaged.FAILURE:
		case reMeasurementUnitConstants.GetPagedAudit.FAILURE:
		case reMeasurementUnitConstants.GetPagedAll.FAILURE:
		case reMeasurementUnitConstants.GetList.FAILURE:
		case reMeasurementUnitConstants.Create.FAILURE:
		case reMeasurementUnitConstants.Delete.FAILURE:
		case reMeasurementUnitConstants.Restore.FAILURE:
		case reMeasurementUnitConstants.Update.FAILURE:
			return {
				...state,
				isSending : false,
				error     : action.payload,
				changed   : null
			}
		case reMeasurementUnitConstants.GetPaged.SUCCESS:
		case reMeasurementUnitConstants.GetPagedAll.SUCCESS:
			return {
				...state,
				isSending : false,
				paged     : action.payload.result
			}
		case reMeasurementUnitConstants.GetPagedAudit.SUCCESS:
			return {
				...state,
				isSending  : false,
				pagedAudit : action.payload.result.items,
				countAudit : action.payload.result.count
			}
		case reMeasurementUnitConstants.GetList.SUCCESS:
			return {
				...state,
				isSending : false,
				list      : action.payload.result
			}
		case reMeasurementUnitConstants.Create.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.create : null
			}
		case reMeasurementUnitConstants.Delete.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.delete : null
			}
		case reMeasurementUnitConstants.Update.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.update : null
			}
		case reMeasurementUnitConstants.Restore.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.restore : null
			}
		case reMeasurementUnitConstants.CLEAR:
			return {
				...state,
				changed    : null,
				isSending  : false,
				paged      : {},
				list       : [],
				pagedAudit : null,
				countAudit : null
			}
		default:
			return state
	}
}